exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 640px){.subscription-steps{display:none}}\n", ""]);

// exports
exports.locals = {
	"subscription-steps": "subscription-steps"
};